export default __webpack_public_path__ + "static/media/logo.da15142c.svg";